import { render } from "./JobBoardItem.vue?vue&type=template&id=9bdbe734&scoped=true&ts=true"
import script from "./JobBoardItem.vue?vue&type=script&lang=ts"
export * from "./JobBoardItem.vue?vue&type=script&lang=ts"

import "./JobBoardItem.vue?vue&type=style&index=0&id=9bdbe734&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bdbe734"]])

export default __exports__